<div class="ch-panel-content d-flex flex-column">
  <h3>Client Invite Email</h3>
  <p [ngClass]="{ 'component-loading': true }">
    The text below (to help you introduce Client Hub) will be used in each
    client invite sent by your firm
  </p>
  <textarea
    type="text"
    class="form-control flex-grow"
    name=""
    id=""
    style="width: 600px"
    [(ngModel)]="defaultEmail"
    placeholder="Default email message"
  ></textarea>
  <div style="margin-top: 16px">
    <button
      class="btn btn-primary"
      style="display: block; width: 140px"
      (click)="changeDefaultInviteEmail()"
    >
      Save
    </button>
  </div>
</div>
